import { createSlice } from '@reduxjs/toolkit'

export const headerSlice = createSlice({
    name: 'header',
    initialState: {
        pageTitle: "Home",  // current page title state management
        noOfNotifications : 0,
        newNotificationMessage : "",  // message of notification to be shown
        newNotificationStatus : 1,   // to check the notification type -  success/ error/ info
        notifications: [],
    },
    reducers: {
        setPageTitle: (state, action) => {
            state.pageTitle = action.payload.title
        },

        removeNotificationMessage: (state, action) => {
            state.newNotificationMessage = ""
        },

        showNotification: (state, action) => {
            state.newNotificationMessage = action.payload.message
            state.newNotificationStatus = action.payload.status
        },

        addNotification: (state, action) => {
            const isRead = action.payload.read ?? false
            state.notifications.unshift({ ...action.payload, read: isRead })
            if (!isRead) state.noOfNotifications += 1
        },

        markNotificationRead: (state, action) => {
            const notification = state.notifications[action.payload]
            if (notification && !notification.read) {
                notification.read = true
                state.noOfNotifications = Math.max(0, state.noOfNotifications - 1)
            }
        },

        clearNotifications: (state) => {
            state.notifications = []
            state.noOfNotifications = 0
        },
    }
})

export const { setPageTitle, removeNotificationMessage, showNotification, addNotification, markNotificationRead, clearNotifications } = headerSlice.actions

export default headerSlice.reducer